<div [formGroup]="form">
  <div *ngIf="!field.value" class="drop-container dropzone" dropZone
       (dropped)="field.onUpload($event)">
    <p class="m-0">
      Drag a file here or
      <label class="upload-button">
        <input type="file" multiple="" (change)="field.onUpload($event.target.files)"> browse
      </label>
      to upload.
    </p>
  </div>
  <div *ngIf="field.value">
    <!-- <button type="button" class="btn btn-primary">Change</button> -->
    <div class="card">
      <img class="card-img-top" [src]="field.value">
    </div>
  </div>
</div>
